import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { persist } from "zustand/middleware";
import { AnnouncementMessage } from "../models";

type State = {
    dismissedAnnouncementId: string | null;
    liveAnnouncement: AnnouncementMessage | null;
    previewAnnouncement: AnnouncementMessage | null;
};

type Action = {
    setDismissedAnnouncementId: (id: string | null) => void;
    setLiveAnnouncement: (announcement: AnnouncementMessage | null) => void;
    setPreviewAnnouncement: (announcement: AnnouncementMessage | null) => void;
};

export const useAnnouncementsStore = create<State & Action>()(
    persist(
        immer((set) => ({
            dismissedAnnouncementId: null,
            liveAnnouncement: null,
            previewAnnouncement: null,
            setDismissedAnnouncementId: (id) =>
                set((state) => {
                    state.dismissedAnnouncementId = id;
                }),
            setLiveAnnouncement: (announcement) =>
                set((state) => {
                    state.liveAnnouncement = announcement;
                }),
            setPreviewAnnouncement: (announcement) =>
                set((state) => {
                    state.previewAnnouncement = announcement;
                }),
        })),
        {
            name: "announcements-storage",
            partialize: (state) => ({
                dismissedAnnouncementId: state.dismissedAnnouncementId,
            }),
        }
    )
);
